import React, {useEffect, useRef} from "react";
import {Avatar, Card, CardContent, CardMedia, Grid, Stack, Typography, Badge} from "@mui/material";
import {styled} from '@mui/material/styles';
import {makeStyles} from "@mui/styles";

const StyledBadge = styled(Badge)(({theme, badgecolor}) => ({
    '& .MuiBadge-badge': {
        backgroundColor: badgecolor,
        color: badgecolor,
        boxShadow: `0 0 0 2px #f7ece8`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            content: '""',
        },
    }
}));

const Slack = ({data}) => {
    const classes = useStyles();
    const containerRef = useRef(null);

    const rows = [[], [], []];

    data.forEach((item, index) => {
        rows[index % 3].push(item);
    });

   /* useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const scrollDuration = 19750;
        const totalScrollDistance = container.scrollWidth - container.clientWidth;
        let startTime = null;

        const animateScroll = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const elapsed = currentTime - startTime;

            // Calculate scroll position as a function of elapsed time
            const scrollPosition = (elapsed / scrollDuration) * totalScrollDistance;
            container.scrollLeft = scrollPosition;

            if (elapsed < scrollDuration) {
                requestAnimationFrame(animateScroll); // Continue animation
            }
        };

        // Start the scrolling animation
        requestAnimationFrame(animateScroll);

        return () => cancelAnimationFrame(animateScroll); // Cleanup on component unmount
    }, []);*/

    return (
        <div ref={containerRef} className={classes.container}>
            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className={classes.row}>
                    {row.map((item, itemIndex) => (
                        <Card className={classes.card} key={itemIndex} style={itemIndex === 0 ? {marginLeft: 0} : {}}>
                            <Typography variant="subtitle2"
                                        className={classes.cityText}>{item.location === "se" ? "Malmö" : "Lisboa"}</Typography>
                            <CardMedia
                                component="img"
                                image={item.location === "se" ? `${process.env.PUBLIC_URL}/images/malmo.png` : `${process.env.PUBLIC_URL}/images/lisbon.png`}
                                alt="img"
                                height="120"
                            />
                            <CardContent className={classes.cardContent}>
                                <Stack direction="row" spacing={2} className={classes.stack}>
                                    <StyledBadge
                                        overlap="circular"
                                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                        variant="dot"
                                        badgecolor={item.presence === "active" ? "#0eb92b" : "#e6251e"}
                                    >
                                        <Avatar alt="user-image" src={item.profileImage} sx={{width: 56, height: 56}}/>
                                    </StyledBadge>
                                </Stack>
                                <div className={classes.contentWrap}>
                                    <Typography variant="subtitle1" gutterBottom
                                                className={classes.name}>{item.name}</Typography>
                                    <div className={classes.statusWrap}>
                                        {item.statusIcon &&
                                            <img src={item.statusIcon} alt="status-icon" width={18} height={18}
                                                 className={classes.statusIcon}/>}
                                        <Typography variant="subtitle2"
                                                    className={!item.status_text ? classes.hiddenStatusText : ""}>{item.status_text || "hidden status"}</Typography>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            ))}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        overflowX: "scroll",
        whiteSpace: "nowrap",
        marginRight: 30,
        marginLeft: 30,
        scrollbarWidth: "none", // Hides scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Hides scrollbar in Chrome, Safari, and Edge
        }
    },
    row: {
        display: "flex",
        marginBottom: 24,
    },
    cardContent: {
        position: "relative",
        backgroundColor: "#f7ece8",
        padding: "16px !important",
    },
    stack: {
        position: "absolute",
        top: "-28px",
        justifyContent: "center",
        margin: "auto",
        left: 0,
        right: 0
    },
    contentWrap: {
        textAlign: "center",
        paddingTop: 30,
        display: "flex",
        flexDirection: "column",
    },
    name: {
        fontWeight: "600 !important",
        fontSize: "18px !important",
        marginBottom: "5px !important"
    },
    statusWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    card: {
        position: "relative",
        marginLeft: 30,
        width: 225,
        flexShrink: 0,
        height: "calc((100vh / 3) - 107px)",
        backgroundColor: "#f7ece8 !important"
    },
    cityText: {
        position: "absolute",
        top: 10,
        right: 15,
        color: "#ffffff",
        fontWeight: "800 !important"
    },
    statusIcon: {
        marginRight: 3,
        marginTop: "-4px"
    },
    hiddenStatusText: {
        color: "transparent"
    }
}));

export default Slack;